import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  filterBox: {
    width: "100%",
    "& .MuiAutocomplete-root": {
      padding: 0,
    },
    "& .MuiOutlinedInput-root": {
      padding: "6px 12px",
      height: 40,
      fontSize: "13px",
      borderRadius: 8,
      backgroundColor: theme.palette.mode === "light" ? "rgba(0,0,0,0.02)" : "rgba(255,255,255,0.02)",
      border: `1px solid ${theme.palette.divider}`,
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.04)",
      },
      "&.Mui-focused": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
      },
    },
    "& .MuiAutocomplete-tag": {
      margin: "2px 4px",
      height: 26,
      fontSize: "12px",
    },
  },
}));

export function StatusFilter({ onFiltered }) {
  const classes = useStyles();
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {}
    fetchData();
  }, []);

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  const status = [
    {
      status: "open",
      name: `${i18n.t("tickets.search.filterConectionsOptions.open")}`,
      color: "#4CAF50",
    },
    {
      status: "closed",
      name: `${i18n.t("tickets.search.filterConectionsOptions.closed")}`,
      color: "#F44336",
    },
    {
      status: "pending",
      name: `${i18n.t("tickets.search.filterConectionsOptions.pending")}`,
      color: "#FF9800",
    },
    { status: "group", name: "Grupos", color: "#2196F3" },
  ];

  return (
    <Box className={classes.filterBox}>
      <Autocomplete
        multiple
        size="small"
        options={status}
        value={selecteds}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => option.status === value.status}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option.color || "#2196F3",
                textShadow: "1px 1px 1px #000",
                color: "white",
                fontWeight: 'bold',
                border: 'none',
                height: 28,
                fontSize: '12px',
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="📊 Status"
          />
        )}
      />
    </Box>
  );
}
